import React from "react";
import {
    Stack,
    FormControl,
    useColorModeValue,
    GridItem,
    FormLabel,
    NumberInput,
    NumberInputField,
    Flex,
    Heading,
    Text,
    Button,
    Center,
    Spinner,
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer
} from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import { useState, useContext } from "react";
import UserContext from "../State/UserContext";
import ModalInfo from "./ModalInfo";

export default function InformacionPrestador() {

    const { user } = useContext(UserContext);

    return (
        <Flex
            height="100vh"
            alignItems="center"
            justifyContent="center"
            backgroundColor="gray.100"
        >
            <Stack
                boxShadow="md"
                bg={useColorModeValue("white", "gray.600")}
                rounded={"xl"}
                p={10}
                spacing={8}
                align={"center"}
            >
                <Stack align={"center"} spacing={2}>
                    <Heading
                        textTransform={"uppercase"}
                        fontSize={"3xl"}
                        color={useColorModeValue("gray.600", "gray.200")}
                    >
                        Información para prestadores
                    </Heading>
                    <Text textAlign="center" fontSize={"lg"} color={"gray.600"}>
                        Por favor haga click en el siguiente botón para leer el instructivo de normas operativas del Plan de Salud del Hospital Británico.
                    </Text>
                </Stack>
                <ModalInfo/>
            </Stack>
        </Flex>
    );
}
